import { ApplicationRef } from '@angular/core';
import { CorrelationMatrixPageModule } from 'PortfolioOptimizerApp/features/correlation-matrix-page/correlation-matrix-page.module';
import { BaseSecurityPageModule } from 'SecuritiesApp/ts/apps/base-security-page/app.module';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { CorrelationMatrixPageComponent } from 'PortfolioOptimizerApp/features/correlation-matrix-page/correlation-matrix-page.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import * as i0 from "@angular/core";
export class MutualFundsCorrelationMatrixAppModule {
    ngDoBootstrap(appRef) {
        appRef.bootstrap(CorrelationMatrixPageComponent);
        appRef.bootstrap(SecurityHeaderControlComponent);
        appRef.bootstrap(TopBarNavComponent);
        appRef.bootstrap(SideMenuComponent);
    }
}
MutualFundsCorrelationMatrixAppModule.ɵfac = function MutualFundsCorrelationMatrixAppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsCorrelationMatrixAppModule)(); };
MutualFundsCorrelationMatrixAppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsCorrelationMatrixAppModule });
MutualFundsCorrelationMatrixAppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseSecurityPageModule, CorrelationMatrixPageModule] });
